<template>
  <div class="home">
    <div class="top">
      <van-popup v-model="show" get-container="body" :style="{ height: '85%', width: '96%' }" :closeable="true">
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            列表
          </div>
          <div class="itme-wrapper" v-if="showbottleList.length">
            <div v-for="(item, index) in showbottleList" :key="index" style="padding: 0 0 10px; position: relative">
              <div class="items">
                <span class="item-name">登记单位：</span>
                <span class="item-value">{{ item.ownerDeptName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">气瓶编号：</span>
                <span class="item-value">{{ item.bottleId || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">填充介质：</span>
                <span class="item-value">{{ item.gasTypeName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">入库时间：</span>
                <span class="item-value">{{ item.incomingTime || '-' }}</span>
              </div>
            </div>
          </div>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false">关闭</van-button>
          </div>
        </div>
      </van-popup>
      <div class="homes">
        <van-tabs v-model="active" @click="initContent" color="#4597ff">
          <van-tab title="入库申请">
            <div>
              <div class="modals bggrey">
                <van-form ref="appForm" @submit="onSubmit" @failed="failed" validate-trigger="onSubmit"
                  label-align="center" :scroll-to-error="true" :validate-first="true">
                  <van-field :readonly="true" v-model="appForm.ownerDeptName" @click="openPicker1('1')" label="登记单位"
                    placeholder="请选择登记单位" :required="true" :rules="[{ required: true, message: '请选择登记单位' }]" />
                  <van-field :readonly="true" v-model="appForm.gasTypeName" @click="openPicker1('2')" label="填充介质"
                    placeholder="请选择填充介质" :required="true" :rules="[{ required: true, message: '请选择填充介质' }]" />
                  <van-field type="number" label="入库个数" v-model="appForm.incomingCount" placeholder="请输入入库个数"
                    :required="true" :rules="[{ required: true, message: '' }]" />
                  <van-field :readonly="true" v-model="appForm.gasStatusName" @click="openPicker1('3')" label="气瓶状态"
                    placeholder="请选择气瓶状态" :required="false" />
                  <div class="flex alcenter between">
                    <van-field :readonly="true" class="flex1 saomabe" v-model="appForm.auditerName"
                      @click="openPicker1('4')" label="审批人" placeholder="请选择审批人" :required="true"
                      :rules="[{ required: true, message: '请选择审批人' }]" />
                    <div class="saoma" @click="scanQRcode">扫码入库</div>
                  </div>

                  <van-popup v-model="showPicker" round position="bottom" get-container="#app">
                    <van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns" @confirm="pickerConfirm"
                      @cancel="pickerCancel" />
                  </van-popup>
                  <div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh">
                    入库列表 (已入库：{{ appForm.bottleList.length }},剩余：{{ appForm.incomingCount - appForm.bottleList.length }})
                  </div>
                  <div class="itme-wrapper" v-if="appForm.bottleList.length">
                    <div v-for="(item, index) in appForm.bottleList" :key="index"
                      style="padding: 0 0 10px; position: relative">                      
                      <div class="items">
                        <span class="item-name">气瓶编号：</span>
                        <span class="item-value">{{ item.bottleId }}</span>
                      </div>
                      <div class="items">
                        <span class="item-name">末检年月：</span>
                        <span class="item-value">{{ item.lastCheckDate }}</span>
                      </div>
                      <div class="items">
                        <span class="item-name">下检年月：</span>
                        <span class="item-value">{{ item.nextCheckDate }}</span>
                      </div>
                      <div class="items">
                        <span class="item-name">报废年月：</span>
                        <span class="item-value">{{ item.scrapDate }}</span>
                      </div>
                      <van-button type="danger" size="small" class="delete-btn" native-type="button"
                        @click="deleteItem">删除</van-button>
                    </div>
                  </div>
                  <div style="position: fixed; bottom: 0" class="flex w100">
                    <van-button class="flex1 w47" style="border-right: 3px solid #fff" square @click="reset" block
                      type="info" native-type="button">重置</van-button>
                    <van-button class="flex1 w47" square block type="info" native-type="submit">提交</van-button>
                  </div>
                </van-form>
              </div>
            </div>
          </van-tab>
          <van-tab title="入库历史">
            <div>
              <van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
                <div class="history">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
                    <van-cell v-for="(item, index) in historyList" :key="index" style="margin-top: 20px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 20px">
                          <div class="history-item">
                            <span>审核类型：</span>
                            <span>入库审核</span>
                            <!-- <span>{{ item.intervieweeName }}</span> -->
                          </div>
                          <div class="history-item">
                            <span>审核人：</span>
                            <span>{{ item.auditerName }}</span>
                          </div>
                          <div class="history-item">
                            <span>气瓶总数：</span>
                            <span>{{ item.incomingCount || '-' }}瓶</span>
                          </div>
                          <div class="history-item">
                            <span>提交时间：</span>
                            <span>{{ item.incomingTime }}</span>
                          </div>
                        </div>
                        <div class="hisotry-right">
                          <van-button plain type="primary" size="small" class="userBtn" @click="getDetail(item)">列表
                        </van-button>
                        <van-button  v-if="item.auditStatus == 2" plain type="primary" size="small" class="userBtn1" @click="editIncoming(item)">编辑
                        </van-button>
                          <img v-if="item.auditStatus == 0" src="@/assets/visitor/daishenhe.png" alt="" /> 
                          <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />                        
                          <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png"	alt="" />
                        </div>                       
                      </div>
                    </van-cell>
                  </van-list>
                </div>
              </van-pull-refresh>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import tabs from "@/components/tabs.vue";
import {
  addApplyfor,
  queryIncomingHistory,
  queryIncomingDetail,
  bottleInfoQueryAll,
  queryGasType,
  queryBottleStatus,
  queryIncomingAuditor,
  getJsApi,
  queryByQrcode
} from "@/apis/api";
import { Toast, Dialog } from "vant";
import { is } from "core-js/core/object";
export default {
  data() {
    return {
      historyList: [],
      carList: [],
      materialList: [],
      areaList: [],
      routeList: [],
      entranceList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      active: 0,
      showForm: {},
      showbottleList: [],
      appForm: {
        ownerDept: "", //登记单位id
        ownerDeptName: "", //登记单位名称
        gasType: "", //气体类型id
        gasTypeName: "", //气体类型名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        incomingCount: "", //气瓶总数 ,
        gasStatus: "", //气瓶状态
        gasStatusName: "", //状态name
        bottleList: [],
      },
      show: false,
      showPicker: false,
      picker_car: "",
      columns: [],
    };
  },
  mounted() {
    document.title = "气瓶入库";
    this.getSystemConfig()
    // this.getGasDetail()
  },
  methods: {
    getGasDetail(resultStr) {     
      queryByQrcode({
        // qrcode: 'http://www.tl6.cc/3508/0110211602'
        qrcode: resultStr 
        // qrcode: resultStr||'http://www.tl6.cc/3508/0110400870'
        // qrcode: resultStr
      }).then(res => {
        if (res.code == 200) {
          let result = res.result;
          if (this.appForm.ownerDept && result.ownerDept !== this.appForm.ownerDept) {
            return this.$toast(`登记单位不符合，当前扫码气瓶登记单位为${result.ownerDeptName},请重新扫码`);
          }
          //如果选择的是高纯乙炔，如果当前是溶解乙炔则也当做高纯乙炔处理
          if ((this.appForm.gasTypeName == "高纯乙炔" || this.appForm.gasTypeName == "乙炔") && result.gasTypeName == "溶解乙炔") {
            console.log("高纯乙炔、乙炔不校验");
          }
          else if (this.appForm.gasType && result.gasType !== this.appForm.gasType) {
            return this.$toast(`填充介质不符合,当前扫码气瓶填充介质为${result.gasTypeName},请重新扫码`);
          }
          if (this.appForm.gasStatusName && result.bottleStatusName !== this.appForm.gasStatusName) {
            return this.$toast(`气瓶状态不符合,当前扫码气瓶状态为${result.bottleStatusName},请重新扫码`);
          }
          //判断当前气瓶是否在appForm.bottleList中
          let isExist = this.appForm.bottleList.some(item => {
            return item.bottleId == result.bottleId;
          });
          if(isExist){
            return this.$toast(`当前气瓶已在列表中，请勿重复添加`);
          }
          //如果选择的是高纯乙炔，则需要把入库的气瓶填充介质ype改为高纯乙炔
          if (this.appForm.gasTypeName == "高纯乙炔" || this.appForm.gasTypeName == "乙炔") {
            res.result.gasType = this.appForm.gasType;
            res.result.gasTypeName = this.appForm.gasTypeName;
          }
          this.appForm.bottleList.splice(0,0, res.result);                   
          this.$set(this.appForm.bottleList, this.appForm.bottleList);
          if(this.appForm.bottleList.length == this.appForm.incomingCount)   //入库数量等于气瓶总数
          {
            this.$toast("当前入库数量已达到设定值，请提交");
          }
        } else {
          this.$toast(res.message);
        }
      })
    },
    getSystemConfig() {
      console.log(encodeURI(location.href.split('#')[0]));
      getJsApi({
        curUrl: encodeURI(location.href.split('#')[0])
      }).then(res => {
        console.log(res.result);
        if (res.code == 200) {
          let configs = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: configs.appId, // 必填，公众号的唯一标识
            timestamp: configs.timestamp, // 必填，生成签名的时间戳
            nonceStr: configs.nonceStr, // 必填，生成签名的随机串
            signature: configs.signature,// 必填，签名
            jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
          });
          wx.ready((res) => {
            console.log('配置完成，扫码前准备完成')
          })
          wx.error(function (res) {
            console.log('出错了：' + res.errMsg);
          });
        } else {
          this.$toast(res.message);
        }
      }).catch(err => { })
    },
    //扫码
    scanQRcode() {
      if(this.appForm.incomingCount <= 0)
      {
        this.$toast("请先设置入库数量");
        return
      }
      if(this.appForm.bottleList.length == this.appForm.incomingCount)   //入库数量等于气瓶总数
          {
            this.$toast("当前入库数量已达到最大值，请提交");
            return
          }
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (!isWeixin) {
        alert('请用微信打开连接，才可使用扫一扫')
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode",], // 二维码
        success: (res) => {
          console.log(res);
          this.getGasDetail(res.resultStr)
        },
        fail: (err) => {
          console.log(err);
        }
      });
    },
    getDetail(item) {
      this.show = true;
      // this.showForm = item;
      this.getDetailList(item.id);
    },
    //记录详情列表
    getDetailList(id) {
      queryIncomingDetail({
        applyforId: id
      }).then(res => {
        if (res.code == 200) {
          this.showbottleList = res.result;
        } else {
          this.$toast(res.message);
        }
      })
    },
    //删除气瓶
    deleteItem(index, item) {
      Dialog.confirm({
        title: "提示",
        message: "确认删除该气瓶吗？",
      }).then(() => {
        if (this.appForm.bottleList.length >= 1) {
          this.appForm.bottleList.splice(index, 1);
        }
      }).catch(() => { });
    },
    // 打开picker弹窗
    openPicker1(code) {
      if (this.picker_car != code) this.getSysCategory(code);
      this.picker_car = code;
      this.showPicker = true;
    },
    // 选择picker弹窗确定
    pickerConfirm(e) {
      if (this.picker_car == "1") {
        this.appForm.ownerDept = e.id;
        this.appForm.ownerDeptName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.ownerDept == this.appForm.ownerDept;
        })
      } else if (this.picker_car == "2") {
        this.appForm.gasType = e.id;
        this.appForm.gasTypeName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.gasType == this.appForm.gasType;
        })
      } else if (this.picker_car == "3") {
        this.appForm.gasStatus = e.id;
        this.appForm.gasStatusName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.gasStatus == this.appForm.gasStatus;
        })
      } else if (this.picker_car == "4") {
        this.appForm.auditer = e.id;
        this.appForm.auditerName = e.text;
      }
      this.showPicker = false;
    },
    // 选择picker弹窗取消
    pickerCancel() {
      this.showPicker = false;
    },
    //查询picker弹窗列表
    getSysCategory(code) {
      let api = "";
      if (code === "1") {
        api = bottleInfoQueryAll;
      } else if (code === "2") {
        api = queryGasType;
      } else if (code === "3") {
        api = queryBottleStatus;
      } else if (code === "4") {
        api = queryIncomingAuditor;
      }
      this.columns = []
      api().then((res) => {
        if (res.code == 200) {
          if (code === "1") {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.text = i.deptName;
              });
            }
          } else if (code === "4") {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.id = i.uid;
                i.text = i.personName;
              });
            }
          } else {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.text = i.name;
              });
            }
          }
          this.columns = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 重置
    reset() {
      this.appForm = {
        ownerDept: "", //登记单位idid
        ownerDeptName: "", //登记单位名称
        gasType: "", //气体类型id
        gasTypeName: "", //气体类型名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        incomingCount: "", //气瓶总数 ,
        gasStatus: "", //气瓶状态
        gasStatusName: "", //状态name
        bottleList: [],
      }
    },
    editIncoming(item) {
      this.appForm.ownerDept = item.ownerDept;
      this.appForm.ownerDeptName = item.ownerDeptName;
      this.appForm.gasType = item.gasType;
      this.appForm.gasTypeName = item.gasTypeName;
      this.appForm.auditer = item.auditer;
      this.appForm.auditerName = item.auditerName;
      this.appForm.incomingCount = item.incomingCount;
      this.appForm.gasStatus = item.gasStatus;
      this.appForm.gasStatusName = item.gasStatusName;
      queryIncomingDetail({
        applyforId: item.id
      }).then(res => {
        if (res.code == 200) {
          //遍历气瓶清空id
          res.result.forEach((item, index) => {
            item.id = null;
          });
          this.appForm.bottleList = res.result;
        } else {
          this.$toast(res.message);
        }
      })
      this.active = 0;
    },
    // 校验失败
    failed() { },
    // 提交预约
    onSubmit() {
      delete this.appForm.gasStatusName;
      this.appForm.incomingCount = this.appForm.bottleList.length;
      console.log(this.appForm);
      addApplyfor(this.appForm).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message || '提交成功');
          this.reset();
        } else {
          this.$toast(res.message || '提交失败');
        }
      });
    },
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    //历史列表
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      queryIncomingHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result.records;
          this.total = res.result.total;
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 历史列表加载更多
    onLoad() {
      console.log("加载更多");
      if (this.isLoading) return;
      this.pageNo++;
      queryIncomingHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          this.historyList = this.historyList.concat(res.result.records);
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // tab点击
    initContent(value) {
      this.active = value;
      if (value == 0) {
        // 刷新页面
      } else {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getHistoryList();
      }
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
@import url("./warehousing.less");
</style>
